import React from 'react';
import { MenuItemLink } from 'react-admin';
import ListItemActionsMenu from '../../../components/ListItemActionsMenu';

const ListItemActions = ({record, basePath}) => {
  const encodedURI = encodeURIComponent(record.id);
    return (
      <ListItemActionsMenu>
        <MenuItemLink
          to={`${basePath}/${encodedURI}`}
          primaryText="Edit consent solution"
        />
      </ListItemActionsMenu>
    );
}

export default ListItemActions;
